export class FeatureGuideController {
    preferences;
    listeners = new Set();
    revision = 0;
    unsubscribe;
    active = null;
    suppressed = false;
    constructor(preferences) {
        this.preferences = preferences;
        this.unsubscribe = preferences.subscribe(() => { if (!preferences.hydrated)
            this.close(false, 'suppressed'); this.notify(); });
    }
    subscribe = (fn) => { this.listeners.add(fn); return () => { this.listeners.delete(fn); }; };
    getSnapshot = () => this.revision;
    notify = () => { this.revision++; this.listeners.forEach(fn => fn()); };
    register(anchor) {
        this.notify();
        return () => {
            if (this.active === anchor)
                this.close(false, 'unmount');
            this.notify();
        };
    }
    setSuppressed(value) {
        if (value === this.suppressed)
            return;
        this.suppressed = value;
        if (value)
            this.close(false, 'suppressed');
        this.notify();
    }
    open(anchor) {
        if (this.suppressed || !anchor.button.isConnected || anchor.button.disabled)
            return;
        if (this.active === anchor)
            return;
        this.close(false, 'replaced');
        this.active = anchor;
        this.preferences.track('feature_guide_opened', { feature: anchor.id, source: 'dot', placement: 'capture_toolbar' });
        this.preferences.acknowledge(anchor.id);
        this.notify();
    }
    close(restoreFocus = true, reason = 'close') {
        const anchor = this.active;
        this.active = null;
        if (anchor)
            this.preferences.track('feature_guide_closed', { feature: anchor.id, reason, placement: 'capture_toolbar' });
        this.notify();
        if (restoreFocus && anchor?.button.isConnected)
            anchor.button.focus({ preventScroll: true });
    }
    dispose() { this.close(false, 'unmount'); this.unsubscribe(); this.preferences.dispose(); this.listeners.clear(); }
}
/** A separate keyboard target beside the real control; its ordinary click remains untouched. */
export function mountFeatureDot(button, id, controller, activate = () => button.click()) {
    const wrapper = button.ownerDocument.createElement('span');
    wrapper.className = 'oq-feature-anchor';
    button.replaceWith(wrapper);
    wrapper.append(button);
    const dot = button.ownerDocument.createElement('button');
    dot.type = 'button';
    dot.className = 'oq-feature-dot';
    dot.dataset.featureGuide = id;
    dot.setAttribute('aria-label', `Learn about ${({ spacing: 'Spacing', recorder: 'Recorder', inspector: 'Hover inspector' })[id]}`);
    dot.setAttribute('aria-haspopup', 'dialog');
    dot.title = dot.getAttribute('aria-label');
    wrapper.append(dot);
    const anchor = { id, button, activate };
    const unregister = controller.register(anchor);
    let shown = false;
    const observer = typeof IntersectionObserver === 'undefined' ? null : new IntersectionObserver(entries => {
        if (!shown && !dot.hidden && entries.some(entry => entry.isIntersecting)) {
            shown = true;
            controller.preferences.track('feature_dot_shown', { feature: id, placement: 'capture_toolbar' });
        }
    });
    observer?.observe(dot);
    const sync = () => {
        dot.hidden = controller.suppressed || !controller.preferences.isUnseen(id);
        dot.setAttribute('aria-expanded', String(controller.active === anchor));
    };
    const unsubscribe = controller.subscribe(sync);
    dot.addEventListener('pointerdown', event => event.stopPropagation());
    dot.addEventListener('click', event => { event.stopPropagation(); controller.open(anchor); });
    sync();
    return { destroy() { observer?.disconnect(); unsubscribe(); unregister(); wrapper.replaceWith(button); } };
}
//# sourceMappingURL=featureGuideController.js.map